<template>
  <div class="signup-hero">
    <figure>
      <picture :class="{'fade-in-image': fadeHero}">
        <source media="(min-width: 1025px)" :srcset="heroXL" />
        <source media="(min-width: 769px)" :srcset="heroLG" />
        <source media="(min-width: 641px)" :srcset="heroMD" />
        <img @load="loadHero" :src="heroSM" alt="Playkids Sign up Banner" />
      </picture>
      <figcaption>
        <div class="container">
          <img class="junior" src="@/assets/junior.svg" alt="" />
          <div class="content">
            <h1>{{ $t('auth.signUp.hero.title') }}</h1>
            <p>
              {{ $t('auth.signUp.hero.content') }}
            </p>
          </div>
        </div>
      </figcaption>
      <HelperBtn @click.native="goDown()" class="helper" icon="IconArrow" />
    </figure>
  </div>
</template>
<script>
import { getOfferConfig, getDefaultConfig } from '@/config/remote.config'

export default {
  name: 'SignUpHero',
  data: () => ({
    fadeHero: false,
    heroSM: '/img/hero/dummy/hero-sm.png',
    heroMD: '/img/hero/dummy/hero-md.png',
    heroLG: '/img/hero/dummy/hero-lg.png',
    heroXL: '/img/hero/dummy/hero-xl.png'
  }),
  methods: {
    goDown () {
      window.scroll({
        top: window.innerHeight - 70,
        behavior: 'smooth'
      })
    },
    loadHero () {
      if (this.heroSM.indexOf('dummy') < 0) {
        this.fadeHero = true
      }
    }
  },
  async created() {
    if (this.$route.query.offer) {
      const offerConfig = await getOfferConfig(this.$route.query.offer)
      if (offerConfig && offerConfig.signup && offerConfig.signup.hero) {
        this.heroSM = offerConfig.signup.hero.sm
        this.heroMD = offerConfig.signup.hero.md
        this.heroLG = offerConfig.signup.hero.lg
        this.heroXL = offerConfig.signup.hero.xl
      } else {
        this.heroSM = '/img/hero/hero-sm.png'
        this.heroMD = '/img/hero/hero-md.png'
        this.heroLG = '/img/hero/hero-lg.png'
        this.heroXL = '/img/hero/hero-xl.png'
      }
    } else {
      let defaultConfig = await getDefaultConfig(this.$route.query.offer)
      defaultConfig = defaultConfig.ptBr.default
      if (defaultConfig && defaultConfig.offer && defaultConfig.offer.signup && defaultConfig.offer.signup.hero) {
        const heroImg = defaultConfig.offer.signup.hero
        this.heroSM = heroImg.sm
        this.heroMD = heroImg.md
        this.heroLG = heroImg.lg
        this.heroXL = heroImg.xl
      } else {
        this.heroSM = '/img/hero/hero-sm.png'
        this.heroMD = '/img/hero/hero-md.png'
        this.heroLG = '/img/hero/hero-lg.png'
        this.heroXL = '/img/hero/hero-xl.png'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.signup-hero {
  display: flex;
  width: 100vw;
  align-self: center;
  justify-self: center;
  flex-direction: column;
  justify-content: center;

  margin-bottom: 20px;
}
figure {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 600px;
  max-height: calc(100vh - 50px);
  margin: 0;

  background: {
    image: url(/img/hero/section-mark-sm.png);
    size: 100% auto;
    position: center bottom;
    repeat: no-repeat;
  }

  picture {
    position: absolute;
    top: 0;
    width: 100%;
    height: auto;

    &.loaded {
      opacity:1;
      transition:opacity 0.5s linear;
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  figcaption {
    margin-top: 250px;
    @media screen and (min-width: 376px) {
      margin-top: 300px;
    }
    width: 100%;
    padding: 15px;

    .container {
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        display: none;
      }
      .content {
        display: flex;
        flex-direction: column;
        h1 {
          text-align: center;
          color: #F2AB29;
          font-size: 2em;
        }
        p {
          text-align: center;
          font-weight: 500;
          font-size: 1.2em;
        }
      }
    }
  }
  button.helper {
    position: absolute;
    left: calc(50% - 13px);
    bottom: 12px;
  }
}
@media screen and (min-width: 641px) {
  figure {
    min-height: 750px;
    height: 800px;
    background: {
      image: url(/img/hero/section-mark-md.png);
    }

    figcaption {
      margin-top: 350px;
      .container {
        width: 80%;
        margin: auto;
        display: flex;
        flex-direction: row;
        img {
          &.junior {
            display: block;
          }
        }
        .content {
          margin-left: 50px;
          h1 {
            text-align: left;
          }
          p {
            text-align: left;
            font-size: 1.5em;
          }
        }
      }
    }

    button.helper {
      bottom: 24px;
    }
  }
}
@media screen and (min-width: 769px) {
  figure {
    height: 1000px;
    background: {
      image: url(/img/hero/section-mark-lg.png);
    }

    figcaption {
      margin-top: 400px;
      .container {
        width: 50%;
      }
    }

    button.helper {
      bottom: 50px;
    }
  }
}
@media screen and (min-width: 1025px) {
  figure {
    min-height: 750px;
    height: 850px;
    background: {
      image: url(/img/hero/section-mark-xl.png);
    };

    figcaption {
      margin-top: 380px;
      .container {
        width: 600px;
      }
    }

    button.helper {
      bottom: 12px;
    }
  }
}
@media screen and (min-width: 1281px) {
  .signup-hero {
    width: calc(100% + 4rem);
  }
  figure {
    min-height: 850px;
  }
}
@media screen and (min-width: 1441px) {
  figure {
    height: 950px;
    background: {
      size: 1440px auto;
    }
  }
}
</style>
